import { act } from 'react';
import {
  SCHEDULE_GET_PERMISSION_FLAGS_BEGIN,
  SCHEDULE_GET_PERMISSION_FLAGS_SUCCESS,
  SCHEDULE_GET_PERMISSION_FLAGS_FAILURE,
  SCHEDULE_GET_PERMISSION_FLAGS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getPermissionFlags(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: SCHEDULE_GET_PERMISSION_FLAGS_BEGIN,
    });
    const { projectId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}permissions/get`, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: SCHEDULE_GET_PERMISSION_FLAGS_SUCCESS,
              data: res.data,
            });
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: SCHEDULE_GET_PERMISSION_FLAGS_FAILURE,
              data: { error: 'Failed' },
            });
            resolve('Failed');
          }
        },
        (err) => {
          dispatch({
            type: SCHEDULE_GET_PERMISSION_FLAGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPermissionFlagsError() {
  return {
    type: SCHEDULE_GET_PERMISSION_FLAGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_GET_PERMISSION_FLAGS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPermissionFlagsPending: true,
        getPermissionFlagsError: null,
      };

    case SCHEDULE_GET_PERMISSION_FLAGS_SUCCESS:
      // The request is success
      return {
        ...state,
        getPermissionFlagsPending: false,
        getPermissionFlagsError: null,
        permissionFlags: action.data,
      };

    case SCHEDULE_GET_PERMISSION_FLAGS_FAILURE:
      // The request is failed
      return {
        ...state,
        getPermissionFlagsPending: false,
        getPermissionFlagsError: action.data.error,
      };

    case SCHEDULE_GET_PERMISSION_FLAGS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPermissionFlagsError: null,
      };

    default:
      return state;
  }
}
